import React from "react";
import { useTranslation } from "react-i18next";

import { AdminLocationAlertsListRowActions } from "./Actions";
import { AdminLocationAlertsListRowColumn } from "./Column";
import { ListLocations } from "./ListLocations";
import { LocationAlertData } from "../../../../models/LocationAlert";

import "./styles.scss";

export interface IAdminLocationAlertsListRowProps {
  locationAlert?: LocationAlertData;
  isHeader?: boolean;
  sortField?: string;
  sortDirection?: string;
  handleSort?: (sortField: string) => void;
}

export const AdminLocationAlertsListRow: React.FC<
  IAdminLocationAlertsListRowProps
> = ({ isHeader, locationAlert, sortField, sortDirection, handleSort }) => {
  const { t: _t } = useTranslation();
  const t = (key: string, params?: any) =>
    _t(`adminLocationAlertsPage.adminLocationAlertsList.${key}`, params);

  return (
    <div
      className={`admin-location-alerts-list-row ${
        isHeader ? "admin-location-alerts-list-header" : ""
      }`}
    >
      <AdminLocationAlertsListRowColumn
        isHeader={isHeader}
        sortField="label_name"
        headerText={t("header.label_name")}
        itemText={
          locationAlert?.labels?.map((label) => label.name).join(", ") || "-"
        }
        currentSortField={sortField}
        currentSortDirection={sortDirection}
      />
      <AdminLocationAlertsListRowColumn
        isHeader={isHeader}
        handleSort={handleSort}
        sortField="type"
        headerText={t("header.type")}
        itemText={t(`type.${locationAlert?.type}`) || "-"}
        currentSortField={sortField}
        currentSortDirection={sortDirection}
      />
      <AdminLocationAlertsListRowColumn
        isHeader={isHeader}
        sortField="details"
        headerText={t("header.details")}
        itemText={t(`details.${locationAlert?.type}.text`, {
          ...locationAlert?.details,
        })}
        currentSortField={sortField}
        currentSortDirection={sortDirection}
      />
      <AdminLocationAlertsListRowColumn
        isHeader={isHeader}
        sortField="is_alert"
        headerText={t("header.is_alert")}
        currentSortField={sortField}
        currentSortDirection={sortDirection}
      >
        <ListLocations
          locations={
            locationAlert?.recent_statuses
              .filter((status) => status.is_active)
              .map((status) => status.locations) ?? []
          }
        />
      </AdminLocationAlertsListRowColumn>
      <AdminLocationAlertsListRowColumn
        isHeader={isHeader}
        sortField="is_not_alert"
        headerText={t("header.is_not_alert")}
        currentSortField={sortField}
        currentSortDirection={sortDirection}
      >
        <ListLocations
          locations={
            locationAlert?.recent_statuses
              .filter((status) => !status.is_active)
              .map((status) => status.locations) ?? []
          }
        />
      </AdminLocationAlertsListRowColumn>
      <AdminLocationAlertsListRowActions
        isHeader={isHeader}
        locationAlert={locationAlert}
      />
    </div>
  );
};
